/**
 * exportCSV
 *
 * Client-side CSV export. No Lambda, no round trip.
 * Builds a CSV string from an array of records filtered to the
 * provided Set of IDs, then triggers a browser download.
 *
 * @param {Object[]} records    — full records array already in memory
 * @param {Set}      selectedIds — Set of ID strings to include
 * @param {string[]} columns    — ordered list of field names to export
 * @param {string}   filename   — download filename (without .csv extension)
 *
 * Usage:
 *   import { exportCSV } from '../utils/exportCSV';
 *
 *   exportCSV(records, selectedIds, [
 *     'TransactionID', 'GiftDate', 'FirstName', 'LastName',
 *     'SourceCode', 'TotalAmount', 'Status', 'StaffNotes',
 *   ], 'fulfillment_export');
 */
export function exportCSV(records, selectedIds, columns, filename = 'export') {
  const rows = records.filter(r => {
    // Support both string IDs and any primary key field
    const id = r.TransactionID ?? r.id ?? r.ID;
    return selectedIds.has(id);
  });

  if (rows.length === 0) return;

  const escape = v => `"${String(v ?? '').replace(/"/g, '""')}"`;

  const header = columns.join(',');
  const body   = rows.map(r => columns.map(c => escape(r[c])).join(',')).join('\n');
  const csv    = `${header}\n${body}`;

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
